export default __webpack_public_path__ + "images/09153001b8462069aece17b948aa4db1.png";